import React from 'react';
import classNames from 'classnames';
import { Icon, Spinner } from 'ui';
import Skipped from './Grading/Skipped';

export default class IlosVideo extends React.Component {
  render() {
    const {
      modalVisible,
      randtag,
      isCurrentUser,
      lessonTaking,
      skipped,
      questionType,
      loadIlosRecording,
      finished,
    } = this.props;
    const url = 'https://app.ilosvideos.com/';
    const showVideo = modalVisible || lessonTaking;
    const videoStyles = classNames('Video', {
      'Video--playable': modalVisible,
    });
    const autoplay = !lessonTaking ? '?autoplay=1' : '';

    return (
      <div className={videoStyles}>
        {skipped && (
          <Skipped isCurrentUser={isCurrentUser} questionType={questionType} />
        )}
        {showVideo && !skipped && (
          <div>
            {!lessonTaking && (
              <div className="Video--loading">
                <Spinner color="darker" />
                <span className="ml-16">{t('common.loading')}</span>
              </div>
            )}
            <iframe
              title={t('questions.question.screen_recording.iframe_title')}
              allowFullScreen
              className="Video-iframe"
              width="100%"
              height="100%"
              allowTransparency="true"
              style={{ backgroundColor: 'transparent' }}
              frameBorder="0"
              src={url + 'embed/' + randtag + autoplay}
            />
          </div>
        )}
        {lessonTaking && !skipped && !finished && (
          <div className="Video-redo d-f fw-w jc-sb ai-c mt-8 pos-r">
            <span className="c-green">
              <Icon name="check_mark" />{' '}
              {t('questions.question.webcam_recording.recording_complete')}
            </span>
            <div>
              <Icon className="c-brand-blue mr-4" name="new_video" />
              <button
                type="button"
                onClick={loadIlosRecording}
                className="NewButton NewButton--flat VideoResponseQuestion-transparentButton p-0"
              >
                {t('questions.question.screen_recording.try_again')}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
